import { useTheme } from 'styled-components';

import { Message, MessageOptions, MessageType, StyledFlex, Text } from '@dreryk/react-components';

import { patientMedicalDocumentRepositoryTranslationKeys } from '../../translations';

type DocumentTypeCellProps = {
   readonly name: string;
   readonly removed: boolean;
};

const useOptions = (): MessageOptions<{ [MessageType.NEGATIVE]: any }> => {
   const theme = useTheme();
   return {
      [MessageType.NEGATIVE]: {
         color: theme.error,
         backgroundColor: theme.errorLighter,
         labelColor: theme.textBody,
      },
   };
};

export const DocumentTypeCell = (props: DocumentTypeCellProps): JSX.Element => {
   const { name, removed } = props;
   const options = useOptions();

   return (
      <StyledFlex gap={'12px'} alignItems={'center'}>
         <Text testId={'name'} maxLines={3}>
            {name}
         </Text>
         {removed ? (
            <Message
               type={MessageType.NEGATIVE}
               displayIndicator
               label={patientMedicalDocumentRepositoryTranslationKeys.table.removedStatus}
               testId={'removedStatus'}
               options={options}
            />
         ) : null}
      </StyledFlex>
   );
};
